import { render, staticRenderFns } from "./done.vue?vue&type=template&id=3d8df10a&scoped=true&"
import script from "./done.vue?vue&type=script&lang=js&"
export * from "./done.vue?vue&type=script&lang=js&"
import style0 from "./done.vue?vue&type=style&index=0&id=3d8df10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8df10a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8df10a')) {
      api.createRecord('3d8df10a', component.options)
    } else {
      api.reload('3d8df10a', component.options)
    }
    module.hot.accept("./done.vue?vue&type=template&id=3d8df10a&scoped=true&", function () {
      api.rerender('3d8df10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/done.vue"
export default component.exports